import { colors } from 'theme/tokens';
import { formatNumber } from '../utils';

interface Props {
  value?: number | null;
  // signed: hiện dấu +/− và tô màu (dòng lịch sử giao dịch); mặc định chỉ hiện số dư.
  signed?: boolean;
  size?: number;
  strong?: boolean;
}

const StarAmount = ({ value, signed = false, size, strong = true }: Props) => {
  if (value === null || value === undefined) return <span>—</span>;
  // Màu chữ trạng thái của bộ màu (≥4.5:1 trên nền trắng) — xanh/đỏ gốc antd chỉ ~3.5:1.
  const color = signed
    ? value > 0
      ? colors.successInk
      : value < 0
      ? colors.dangerInk
      : undefined
    : undefined;
  const sign = signed && value > 0 ? '+' : '';
  return (
    <span
      style={{
        color,
        fontWeight: strong ? 600 : undefined,
        fontSize: size,
        whiteSpace: 'nowrap',
      }}
    >
      {sign}
      {formatNumber(value)} ⭐
    </span>
  );
};

export default StarAmount;
